import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { Box, Link, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AllQuestionLogs = () => {
    const [questionLogs, setQuestionLogs] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        fetchquestionLogs(page, pageSize);
        loadColumnVisibility()
    }, [page, pageSize]);

        useEffect(() => {
            const token = localStorage.getItem('token');    
            if (!token) {
            console.log("No token found, redirecting to login");
            navigate("/login");
            }
        }, [])

    const fetchquestionLogs = async (page, limit) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}questionlog/question-logs`, {
                params: { page, limit },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setQuestionLogs(response.data.questionLogs);
            setTotalPages(response.data.totalPages);
            setTotalItems(response.data.totalItems);
        } catch (error) {
            toast.error('Failed to fetch question logs');
            console.error('Error fetching question logs:', error);
        }
    };

    const loadColumnVisibility = () => {
        const storedVisibility = localStorage.getItem('questionLogsColumnVisibility');
        if (storedVisibility) {
            setColumnVisibilityModel(JSON.parse(storedVisibility));
        }
    };

    const saveColumnVisibility = (model) => {
        console.log("save cloumn Visibility")
        localStorage.setItem('questionLogsColumnVisibility', JSON.stringify(model));
        setColumnVisibilityModel(model);
    };


    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const columns = [
        { field: 'questionText', headerName: 'Question Text', flex: 3 },
        { field: 'profileName', headerName: 'Account Name', flex: 3 },

        {
            field: 'questionLink',
            headerName: 'Question Link',
            flex: 3,
            renderCell: (params) => (
                <Link href={params.value} color={'white'} target="_blank" rel="noopener noreferrer" underline="hover">
                    {params.value}
                </Link>
            ),
        },
        { field: 'runTime', headerName: 'Run Time', flex: 2, valueGetter: ({ value }) => new Date(value).toLocaleString() },
    ];

    const rows = questionLogs.map((log) => ({
        id: log._id,
        profileName: log?.account_id?.profileName || "",
        questionText: log.questionText,
        questionLink: log.questionLink,
        runTime: log.runTime,
    }));

    return (
        <Box sx={{ width: '100%', height: '80vh', p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Question Logs
            </Typography>

            <Box sx={{ height: '85vh', width: '95%', margin: 'auto' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    rowsPerPageOptions={[10, 20, 50]} // Add page size options
                    pagination
                    paginationMode="server"
                    rowCount={totalItems}
                    page={page - 1} // DataGrid uses 0-based index for pagination
                    onPaginationModelChange={(newPaginationModel) => handlePageChange(newPaginationModel.page + 1)} // Handle page changes
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} // Handle page size changes
                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) => saveColumnVisibility(newModel)}
                    sx={{
                        fontFamily: 'Poppins, sans-serif',
                        '& .MuiDataGrid-columnHeaders': {
                            color: 'white',
                            fontSize: '1.25rem',
                            alignSelf: "flex-end"
                        },
                        '& .MuiButtonBase-root': {
                            color: 'white',
                        },
                        '& .MuiDataGrid-row': {
                            backgroundColor: 'linear-gradient(to right, #000000, #06041f, #0d0d55, #15178e)',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#2D3748',
                            },
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: 'linear-gradient(to right, #000000, #06041f, #0d0d55, #15178e)',
                            color: 'white',
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-displayedRows': {
                            color: 'white',
                        },
                        '& .MuiDataGrid-cell': {
                            justifyContent: 'center',
                            display: 'flex',
                            alignItems: 'center',
                        },
                        '& .super-app-theme--header': {
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                                textAlign: 'center',
                                flex: 1,
                                justifyContent: 'center',
                            },
                        },
                        '& .MuiCheckbox-root svg': {
                            color: '#2b9fdb',
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default AllQuestionLogs;

